import { useState, useEffect, useRef } from 'react';
import InfoModal from './InfoModal.js';
import SpinWheel from '../Siniflar/SpinWheel.js';
import { getCurrentPokemonId, getPokemonImage } from './PokemonData'; 

const SOUNDS = {
    shuffle: new Audio('https://assets.mixkit.co/active_storage/sfx/2013/2013-preview.mp3'),
    click: new Audio('https://assets.mixkit.co/active_storage/sfx/2568/2568-preview.mp3'),
    alarm: new Audio('https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3')
};
SOUNDS.shuffle.volume = 0.5; SOUNDS.click.volume = 0.4; SOUNDS.alarm.volume = 0.8;

// İkonlar
const UsersIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>;
const ShuffleIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 3 21 3 21 8" /><line x1="4" y1="20" x2="21" y2="3" /><polyline points="16 16 21 16 21 21" /><line x1="15" y1="15" x2="21" y2="21" /><line x1="4" y1="4" x2="11" y2="11" /></svg>;
const TimerIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const WheelIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="2" x2="12" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/><line x1="4.93" y1="19.07" x2="19.07" y2="4.93"/></svg>;
const MusicIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle></svg>;
const PauseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>;

// --- SAYAÇ MODALI ---
const TimerModalContent = ({ onClose }) => {
    const [timeLeft, setTimeLeft] = useState(300);
    const [isRunning, setIsRunning] = useState(false);
    const [inputMin, setInputMin] = useState(5);

    useEffect(() => {
        let timer;
        if (isRunning && timeLeft > 0) {
            timer = setInterval(() => { setTimeLeft(prev => prev - 1); }, 1000);
        } else if (isRunning && timeLeft === 0) {
            setIsRunning(false);
            try { SOUNDS.alarm.play().catch(()=>{}); } catch(e){}
        }
        return () => clearInterval(timer);
    }, [isRunning, timeLeft]);

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    };

    return (
        <div style={{ textAlign: 'center', padding: '1rem' }}>
            <div style={{ fontSize: '5rem', fontWeight: 'bold', color: timeLeft === 0 ? '#dc3545' : '#333', fontFamily: 'monospace', marginBottom: '1rem' }}>{formatTime(timeLeft)}</div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '20px' }}>
                <button onClick={() => setIsRunning(!isRunning)} className="ct-btn" style={{ background: isRunning ? '#ffc107' : '#198754', color: '#fff', fontSize: '1.2rem', padding: '10px 20px' }}>{isRunning ? 'Duraklat' : 'Başlat'}</button>
                <button onClick={() => { setIsRunning(false); setTimeLeft(inputMin * 60); }} className="ct-btn" style={{ background: '#6c757d', color: '#fff', fontSize: '1.2rem', padding: '10px 20px' }}>Sıfırla</button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginTop: '30px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
                <span>Dakika Ayarla:</span>
                <input type="number" min="1" max="60" value={inputMin} onChange={(e) => setInputMin(e.target.value)} style={{ width: '60px', padding: '5px', fontSize: '1rem' }} />
                <button onClick={() => { setIsRunning(false); setTimeLeft(inputMin * 60); }} className="ct-btn" style={{ padding: '5px 15px', background: '#0d6efd', color: '#fff' }}>Uygula</button>
            </div>
        </div>
    );
};

// --- RASTGELE ÖĞRENCİ MODALI ---
const RandomStudentModalContent = ({ student, onScoreChange, onClose }) => {
    const baseAvatarId = student.avatarId || 1;
    const currentPokemonId = getCurrentPokemonId(baseAvatarId, student.score);
    const pokemonImageUrl = getPokemonImage(currentPokemonId);

    const handleScoreClick = (delta) => {
        try { if (!SOUNDS.click.paused) SOUNDS.click.currentTime = 0; SOUNDS.click.play().catch(() => {}); } catch (e) {}
        onScoreChange(student.id, student.score + delta);
        setTimeout(() => { onClose(); }, 150); 
    };

    return (
        <div style={{ textAlign: 'center', padding: '1.5rem' }}>
            <h3 style={{ color: '#6c757d', fontWeight: 'normal', margin: 0 }}>Rastgele Seçilen Öğrenci</h3>
            <img src={pokemonImageUrl} alt={student.name} style={{ width: '180px', height: '180px', margin: '15px auto', objectFit: 'contain', filter: 'drop-shadow(0 5px 5px rgba(0,0,0,0.2))' }} />
            <p style={{ fontSize: '2rem', fontWeight: '800', color: '#333', margin: '0.5rem 0' }}>{student.name}</p>
            <p style={{ fontSize: '1.2rem', color: '#555', marginBottom: '2rem'}}>Mevcut Puan: <strong style={{ color: '#0d6efd' }}>{student.score}</strong></p>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
                <div className="ct-btn-group" style={{ gap: '10px', display: 'flex', justifyContent: 'center' }}>
                    <button onClick={() => handleScoreClick(1)} className="ct-action-btn btn-plus" style={{ padding: '0.8rem 1.5rem', fontSize: '1.2rem', borderRadius: '8px' }}>+1</button>
                    <button onClick={() => handleScoreClick(2)} className="ct-action-btn btn-plus" style={{ padding: '0.8rem 1.5rem', fontSize: '1.2rem', borderRadius: '8px' }}>+2</button>
                    <button onClick={() => handleScoreClick(3)} className="ct-action-btn btn-plus" style={{ padding: '0.8rem 1.5rem', fontSize: '1.2rem', borderRadius: '8px' }}>+3</button>
                </div>
                <div className="ct-btn-group" style={{ gap: '10px', display: 'flex', justifyContent: 'center' }}>
                    <button onClick={() => handleScoreClick(-1)} className="ct-action-btn btn-minus" style={{ padding: '0.5rem 1.5rem', fontSize: '1rem', borderRadius: '8px' }}>-1</button>
                    <button onClick={() => handleScoreClick(-2)} className="ct-action-btn btn-minus" style={{ padding: '0.5rem 1.5rem', fontSize: '1rem', borderRadius: '8px' }}>-2</button>
                    <button onClick={() => handleScoreClick(-3)} className="ct-action-btn btn-minus" style={{ padding: '0.5rem 1.5rem', fontSize: '1rem', borderRadius: '8px' }}>-3</button>
                </div>
            </div>
        </div>
    );
};

const ActionButtons = ({ students = [], onScoreChange }) => {
    const [modal, setModal] = useState({ isOpen: false, content: null, title: '', maxWidth: '500px' });
    const [pickedStudentsHistory, setPickedStudentsHistory] = useState([]);
    
    // --- ODAKLANMA SESİ (FOCUS AUDIO) STATE'İ ---
    const [isFocusPlaying, setIsFocusPlaying] = useState(false);
    const focusAudioRef = useRef(null);

    useEffect(() => { setPickedStudentsHistory([]); }, [students.length]);
    const closeModal = () => setModal({ isOpen: false, content: null, title: '', maxWidth: '500px' });

    // Focus Audio'yu sisteme bağla (YENİ DOSYA YOLU EKLENDİ)
    useEffect(() => {
        // public klasöründeki dosyayı çağırıyoruz
        focusAudioRef.current = new Audio('/sesler/cartoon-music-soundtrack-menu-screen-_-lobby-music-9-466019.mp3');
        focusAudioRef.current.loop = true; // Sonsuz döngü
        focusAudioRef.current.volume = 0.3; // Sınıf ortamı için kısık ses

        return () => {
            if (focusAudioRef.current) {
                focusAudioRef.current.pause();
            }
        };
    }, []);

    const toggleFocusSound = () => {
        if (isFocusPlaying) {
            focusAudioRef.current.pause();
            setIsFocusPlaying(false);
        } else {
            focusAudioRef.current.play().catch(() => {});
            setIsFocusPlaying(true);
        }
    };

    const handleGroupGeneration = () => {
        if (students.length === 0) { alert("Sınıfta öğrenci bulunmuyor!"); return; }
        const groupSize = parseInt(window.prompt("Her grupta kaç kişi olsun? (Örn: 2, 3, 4)"), 10);
        if(!groupSize || isNaN(groupSize)) return;

        try { SOUNDS.click.play().catch(() => {}); } catch (e) {}
        
        let shuffled = [...students];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }

        const groups = [];
        for (let i = 0; i < shuffled.length; i += groupSize) {
            groups.push(shuffled.slice(i, i + groupSize));
        }

        setModal({ isOpen: true, title: `${groupSize}'li Gruplar`, maxWidth: '700px', content: (
            <div className="ct-group-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
                {groups.map((group, index) => (
                    <div key={index} style={{ border: '1px solid #eee', borderRadius: '8px', padding: '10px', background: '#f9f9f9' }}>
                        <h5 style={{ color: '#0d6efd', margin: '0 0 10px 0', textAlign: 'center' }}>Grup {index + 1}</h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'center' }}>
                            {group.map(student => <li key={student.id} style={{ padding: '4px 0', borderBottom: '1px solid #eee' }}>{student.name}</li>)}
                        </ul>
                    </div>
                ))}
            </div>
        )});
    };

    const handleRandomPick = () => {
        if (students.length === 0) { alert("Sınıfta öğrenci bulunmuyor!"); return; }
        try { if (!SOUNDS.shuffle.paused) SOUNDS.shuffle.currentTime = 0; SOUNDS.shuffle.play().catch(() => {}); } catch (e) {}

        let availableStudents = students.filter(s => !pickedStudentsHistory.includes(s.id));
        if (availableStudents.length === 0) {
            availableStudents = students;
            setPickedStudentsHistory([]);
        }
        
        const randomStudent = availableStudents[Math.floor(Math.random() * availableStudents.length)];
        setPickedStudentsHistory(prev => [...prev, randomStudent.id]);
        
        setModal({ isOpen: true, title: `Şanslı Öğrenci (Kalan: ${availableStudents.length - 1}/${students.length})`, maxWidth: '500px', content: <RandomStudentModalContent student={randomStudent} onScoreChange={onScoreChange} onClose={closeModal} /> });
    };

    const openTimerModal = () => setModal({ isOpen: true, title: 'Sınıf Sayacı', maxWidth: '400px', content: <TimerModalContent onClose={closeModal} /> });
    const openWheelModal = () => setModal({ isOpen: true, title: 'Sınıf Çarkıfeleği', maxWidth: '1000px', content: <SpinWheel currentStudents={students} /> });

    return (
        <>
            <InfoModal isOpen={modal.isOpen} onClose={closeModal} title={modal.title} maxWidth={modal.maxWidth}>
                {modal.content}
            </InfoModal>

            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <button onClick={openTimerModal} className="ct-btn-header" style={{ background: '#198754', color: '#fff' }} title="Sayaç">
                    <TimerIcon />
                </button>
                
                {/* ODAKLANMA SESİ BUTONU */}
                <button 
                    onClick={toggleFocusSound} 
                    className="ct-btn-header" 
                    style={{ background: isFocusPlaying ? '#ef4444' : '#0ea5e9', color: '#fff' }} 
                    title={isFocusPlaying ? "Odaklanma Sesini Kapat" : "Odaklanma Sesi Aç"}
                >
                    {isFocusPlaying ? <PauseIcon /> : <MusicIcon />}
                </button>

                <button onClick={openWheelModal} className="ct-btn-header" style={{ background: '#6f42c1', color: '#fff' }} title="Çarkıfelek">
                    <WheelIcon />
                </button>
                <button onClick={handleRandomPick} className="ct-btn-header" style={{ background: '#ffc107', color: '#000' }} title="Rastgele">
                    <ShuffleIcon />
                </button>
                <button onClick={handleGroupGeneration} className="ct-btn-header" style={{ background: '#0dcaf0', color: '#fff' }} title="Grup Yap">
                    <UsersIcon />
                </button>
            </div>
        </>
    );
};

export default ActionButtons;